import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'reactstrap';
import Status from './Status';

const colors = {
  error: 'bg-lightred',
  U: 'bg-lightgreen',
  A: 'bg-light',
};

const getColor = (result) => {
  if (result.type === 'U') {
    if (!result.any_non_equivalent_fields || !result.diff.changed) {
      return 'bg-lightgray';
    }
  }
  return colors[result.type];
};

const ResultsTable = ({ results }) => {
  let span = 1;
  if (results[0] && results[0].row_values) {
    span = results[0].row_values.length;
  }

  return (
    <Table bordered size="sm" className="w-100">
      <thead className="bg-gray">
        <tr>
          <th>Row</th>
          <th colSpan={span}>Status</th>
        </tr>
      </thead>
      <tbody>
        {results.length ? results.map((result) => (
          <React.Fragment key={result.row_number}>
            <tr
              key={result.row_number}
              className={getColor(result)}
            >
              <td>{result.row_number}</td>
              {result.row_values.map((value) => (
                <td key={`Table-${value}`}>{value}</td>
              ))}
            </tr>
            <tr>
              <td />
              <Status result={result} />
            </tr>
          </React.Fragment>
        )) : (
          <tr>
            <td>
              No results to display.
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};

const mapStateToProps = (store) => ({
  results: store.batch.results,
});

export default connect(mapStateToProps)(ResultsTable);
